<template>
  <div>
    <vs-popup
      :title="type == 1 ? $t('ReceiversList') : $t('ReceiverCCList')"
      :active.sync="showModal"
    >
      <ul dir="rtl" style="font-size: 1.5rem;">
        <li v-for="(item, index) in receiversOrReceiverCCList" :key="item">{{ index + 1 }} - 
            <span style="font-weight: bold;">{{ item }}</span>
        </li>
      </ul>
    </vs-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
export default {
  name: "",
  props: {
    show: { default: false },
    receiversOrReceiverCCList: Array,
    type: 0
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  mounted() {}
};
</script>
